import "../css/style.css";
import mapBox from "./leaflet";
import "core-js";
import "regenerator-runtime/runtime";
import process from "process";
import { Buffer } from "buffer";
import login from "./login";
import logout from "./logout";
import updateSettings from "./updateSettings";
import { stripe } from "./stripe";
import { verifyEmail } from "./verifyEmail";
import { showAlert } from "./alerts";
import { signup } from "./signup";
import {forgotPassword} from "./forgotPassword";
import { resetPassword } from "./resetPassword";
import { showAlert } from "./alerts";

window.process = process;
window.Buffer = Buffer;
const mapEl = document.querySelector("#map");
const loginFormEl = document.querySelector("#login-form");
const logoutBtn = document.querySelector("#logout-btn");
const userFormDataEl = document.querySelector("#user-data");
const userFormPasswordEl = document.querySelector("#user-password");
const bookTourBtn = document.querySelector('#book-tour');
const verifyEmailEl = document.querySelector('#verify-email');
const signupFormEl = document.querySelector('#signup-form');
const confirmEmailEl = document.querySelector('#confirm-email');
const forgotPasswordEl = document.querySelector('#forgot_password');
const resetPasswordEl = document.querySelector('#reset_password');



if (window.location.pathname.startsWith("/tour") && mapEl) {
  mapBox();
}

if (window.location.pathname === "/login" && loginFormEl) {
  const {emailVerified} = loginFormEl.dataset;
//  if(!emailVerified) emailVerified = null;
 
  
  if(Boolean(emailVerified)) showAlert('success', 'Email Verified!')

  loginFormEl.addEventListener("submit", async (e) => {
    e.preventDefault();
    
    const email = e.target.querySelector("#email").value;
    const password = e.target.querySelector("#password").value;

    await login(email, password);
  });
}

if (logoutBtn) {
  logoutBtn.addEventListener("click", async () => {
    await logout();
  });
}

if (userFormDataEl) {
  userFormDataEl.addEventListener("submit", async (e) => {
    e.preventDefault();
    const form = new FormData();

    form.append("name", document.querySelector("#name")?.value);
    form.append("email", document.querySelector("#email")?.value);
    form.append("photo", document.querySelector("#photo")?.files[0]);

    await updateSettings(form, "user");

    setTimeout(() => {
      window.location.reload(true);
    }, 1200);
  });
}

if (userFormPasswordEl) {
  userFormPasswordEl.addEventListener("submit", async (e) => {
    e.preventDefault();
    const currentPassword = document.querySelector("#password-current")?.value;
    const newPassword = document.querySelector("#password")?.value;
    const newPasswordConfirm =
      document.querySelector("#password-confirm")?.value;

    await updateSettings(
      { currentPassword, newPassword, newPasswordConfirm },
      "password",
    );
  });
};

if(bookTourBtn){
  bookTourBtn.addEventListener('click', async e => {
    const {tourId} = e.target.dataset; 
    const url = await stripe(tourId);
    window.location.assign(url)

  })
}

const performEmailVerification = async el => {
  const {vToken} = el.dataset;
  if(window.emailVerifyStarted) return;
  window.emailVerifyStarted = true;
  await verifyEmail(vToken);
}

if(verifyEmailEl ){
  performEmailVerification(verifyEmailEl);
}

if(signupFormEl){
  signupFormEl.addEventListener('submit', async e => {
    e.preventDefault();
    const name = e.target.querySelector('#name').value;
    const email = e.target.querySelector('#email').value;
    const password = e.target.querySelector('#password').value;
    const passwordConfirm = e.target.querySelector('#passwordConfirm').value;

    try {
      
      await signup({name, email, password, passwordConfirm});
    } catch (error) {
       
        e.target.querySelector('#password').value = '';
        e.target.querySelector('#passwordConfirm').value = '';

    }

  })
};

if(confirmEmailEl){
  showAlert('success', 'Check your inBox! to confirm you email ')
};

if(forgotPasswordEl){
  forgotPasswordEl.addEventListener('submit', async e => {
    e.preventDefault();
    const email  = e.target.querySelector('#email').value;
    const resetBTN = e.target.querySelector('#reset-btn');
    resetBTN.textContent = 'Sending email...';
    resetBTN.disabled = true;
    await forgotPassword(email);
  })
};

if(resetPasswordEl){
  
  resetPasswordEl.addEventListener('submit', async e => {
    const {resetToken} = resetPasswordEl.dataset;
    const newPassword = document.querySelector('#password').value;
    const newPasswordConfirm = document.querySelector('#passwordConfirm').value;
    e.preventDefault();
    console.log({newPassword, newPasswordConfirm});
    await resetPassword(resetToken, newPassword, newPasswordConfirm);

  });
};

const alertMessage = document.querySelector('body').dataset.alert;
if(alertMessage){
  showAlert('success', alertMessage, 20)
}


console.log("TEST!!!!!!!!!!!!!!!!!");
